import type { SelectedSystemType } from 'data/types';
import { formatBtuOutput } from 'utils/ducted-zone-performance';
import {
  equipmentPlaceholderNote,
  isEquipmentPlaceholderProduct
} from 'utils/equipment-placeholder';

type DuctedSelectedUnitLinesProps = Readonly<{
  zone: SelectedSystemType['configuration']['condensers'][number]['zones'][number] & {
    blowerProduct?: SelectedSystemType['configuration']['condensers'][number]['zones'][number]['selectedProduct'];
  };
}>;

export default function DuctedSelectedUnitLines({
  zone
}: DuctedSelectedUnitLinesProps) {
  const indoor = zone.selectedProduct;
  const indoorPlaceholder = isEquipmentPlaceholderProduct(indoor);
  const indoorNote = equipmentPlaceholderNote(indoor);
  const blower = zone.blowerProduct;
  const blowerPlaceholder = isEquipmentPlaceholderProduct(blower);
  const blowerNote = equipmentPlaceholderNote(blower);
  return (
    <>
      <div>
        {formatBtuOutput(indoor?.coolingBTU ?? 0)}
        <br />
        <span className='text-gray-500'>
          {indoorPlaceholder ? indoor?.name : indoor?.type ?? 'Air Handler'}
        </span>
        {indoorNote && (
          <span className='italic text-gray-400'> {indoorNote}</span>
        )}
      </div>
      {blower && (
        <div className='mt-1'>
          {formatBtuOutput(blower.heatingBTU ?? 0)}
          <br />
          <span className='text-gray-500'>
            {blowerPlaceholder ? blower.name : blower.type || 'Blower'}
          </span>
          {blowerNote && (
            <span className='italic text-gray-400'> {blowerNote}</span>
          )}
        </div>
      )}
    </>
  );
}
